export enum imageType {
    ORDER_SERVICE_IMG_DISPOSE = 23, // 服务单处理
    ORDER_SERVICE_IMG_FINISH = 27, // 服务单完成
    ORDER_TASK_IMG_DISPOSE = 33, // 工单处理
    ORDER_TASK_IMG_APPEAR = 37// 工单完成
  }
